import React from 'react';

const SentimentAnalyzer = ({ onClose = () => {} }) => {
    // Debug: Check if onClose is received
  console.log('SentimentAnalyzer received onClose:', typeof onClose, onClose);

  const handleClose = () => {
    console.log('Close button clicked');
    console.log('onClose type:', typeof onClose);
    if (onClose && typeof onClose === 'function') {
      console.log('Calling onClose function');
      onClose();
    } else {
      console.error('onClose is not a function:', onClose);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-bold">Text Sentiment Dashboard (For Testing Purposes Only)</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold px-2 py-1 rounded hover:bg-gray-100"
            type="button"
          >
            ✕
          </button>
        </div>
        <div className="p-0">
          <iframe
            title="AWS Sentiment Analyzer Application"
            srcDoc={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>AWS Sentiment Analyzer</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            min-height: 100vh;
            padding: 20px;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            background: rgba(255, 255, 255, 0.95);
            border-radius: 20px;
            padding: 30px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
        }

        .header {
            text-align: center;
            margin-bottom: 40px;
        }

        .header h1 {
            color: #333;
            font-size: 2.5em;
            margin-bottom: 10px;
            background: linear-gradient(45deg, #667eea, #764ba2);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }

        .header p {
            color: #666;
            font-size: 1.1em;
        }

        .aws-badge {
            background: #FF9900;
            color: white;
            padding: 5px 15px;
            border-radius: 20px;
            font-size: 0.9em;
            margin: 10px 0;
            display: inline-block;
        }

        .input-section {
            margin-bottom: 30px;
        }

        .input-group {
            margin-bottom: 20px;
        }

        label {
            display: block;
            margin-bottom: 8px;
            font-weight: 600;
            color: #333;
        }

        textarea {
            width: 100%;
            min-height: 150px;
            padding: 15px;
            border: 2px solid #e1e5e9;
            border-radius: 10px;
            font-size: 16px;
            font-family: inherit;
            resize: vertical;
            transition: border-color 0.3s ease;
        }

        textarea:focus {
            outline: none;
            border-color: #667eea;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .controls {
            display: flex;
            gap: 15px;
            flex-wrap: wrap;
            align-items: center;
        }

        button {
            background: linear-gradient(45deg, #667eea, #764ba2);
            color: white;
            border: none;
            padding: 12px 30px;
            border-radius: 25px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
        }

        button:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
        }

        button:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
        }

        .btn-secondary {
            background: linear-gradient(45deg, #ffecd2, #fcb69f);
            color: #333;
        }

        .loading {
            display: none;
            align-items: center;
            gap: 10px;
            color: #667eea;
            font-weight: 600;
        }

        .spinner {
            width: 20px;
            height: 20px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #667eea;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .results-section {
            margin-top: 30px;
            display: none;
        }

        .sentiment-card {
            background: white;
            border-radius: 15px;
            padding: 25px;
            margin-bottom: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            border-left: 5px solid #667eea;
        }

        .sentiment-header {
            display: flex;
            justify-content: between;
            align-items: center;
            margin-bottom: 20px;
            flex-wrap: wrap;
            gap: 15px;
        }

        .sentiment-main {
            font-size: 2em;
            font-weight: bold;
            text-transform: capitalize;
        }

        .sentiment-positive { color: #10B981; }
        .sentiment-negative { color: #EF4444; }
        .sentiment-neutral { color: #6B7280; }
        .sentiment-mixed { color: #F59E0B; }

        .confidence-badge {
            background: #F3F4F6;
            color: #374151;
            padding: 8px 16px;
            border-radius: 20px;
            font-size: 0.9em;
            font-weight: 600;
        }

        .scores-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
            margin-top: 20px;
        }

        .score-item {
            background: #F9FAFB;
            padding: 15px;
            border-radius: 10px;
            text-align: center;
        }

        .score-label {
            font-size: 0.9em;
            color: #6B7280;
            text-transform: capitalize;
        }

        .score-value {
            font-size: 1.5em;
            font-weight: bold;
            margin-top: 5px;
        }

        .score-bar {
            background: #E5E7EB;
            height: 8px;
            border-radius: 4px;
            margin-top: 10px;
            overflow: hidden;
        }

        .score-fill {
            height: 100%;
            border-radius: 4px;
            transition: width 0.5s ease;
        }

        .history-section {
            margin-top: 40px;
        }

        .history-item {
            background: white;
            border-radius: 10px;
            padding: 15px;
            margin-bottom: 15px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
            border-left: 4px solid #E5E7EB;
        }

        .history-text {
            color: #374151;
            margin-bottom: 10px;
            font-style: italic;
        }

        .history-result {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.9em;
        }

        .demo-buttons {
            margin-top: 15px;
        }

        .demo-btn {
            background: linear-gradient(45deg, #a8edea, #fed6e3);
            color: #333;
            padding: 8px 20px;
            margin: 5px;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            cursor: pointer;
        }

        .error {
            background: #FEE2E2;
            color: #DC2626;
            padding: 15px;
            border-radius: 10px;
            margin-top: 20px;
            border-left: 4px solid #DC2626;
        }

        @media (max-width: 768px) {
            .container { padding: 20px; }
            .header h1 { font-size: 2em; }
            .controls { flex-direction: column; width: 100%; }
            button { width: 100%; }
            .sentiment-header { flex-direction: column; align-items: flex-start; }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <h1>🤖 AWS Sentiment Analyzer</h1>
            <div class="aws-badge">Powered by Amazon Comprehend</div>
            <p>Analyze the emotional tone of any text using AWS machine learning</p>
        </div>

        <div class="input-section">
            <div class="input-group">
                <label for="textInput">Enter your text for sentiment analysis:</label>
                <textarea 
                    id="textInput" 
                    placeholder="Type or paste your text here... (e.g., customer feedback, social media posts, reviews, etc.)"
                ></textarea>
            </div>

            <div class="demo-buttons">
                <p><strong>Try these examples:</strong></p>
                <button class="demo-btn" onclick="loadDemo('positive')">😊 Positive Review</button>
                <button class="demo-btn" onclick="loadDemo('negative')">😞 Negative Feedback</button>
                <button class="demo-btn" onclick="loadDemo('mixed')">🤔 Mixed Emotions</button>
                <button class="demo-btn" onclick="loadDemo('neutral')">😐 Neutral Statement</button>
            </div>

            <div class="controls">
                <button onclick="analyzeSentiment()" id="analyzeBtn">
                    🔍 Analyze Sentiment
                </button>
                <button onclick="clearAll()" class="btn-secondary">
                    🗑️ Clear All
                </button>
                <div class="loading" id="loading">
                    <div class="spinner"></div>
                    Processing with AWS Comprehend...
                </div>
            </div>
        </div>

        <div class="results-section" id="resultsSection">
            <h2>📊 Analysis Results</h2>
            <div id="sentimentCard"></div>
        </div>

        <div class="history-section" id="historySection" style="display: none;">
            <h2>📈 Analysis History</h2>
            <div id="historyList"></div>
        </div>

        <div id="error" class="error" style="display: none;"></div>
    </div>

    <script>
        // Demo data
        const demoTexts = {
            positive: "I absolutely love this product! The quality is outstanding and the customer service exceeded my expectations. I would definitely recommend this to all my friends and family. This has made my life so much easier!",
            negative: "This is the worst experience I've ever had. The product broke immediately and customer service was completely unhelpful. I'm extremely disappointed and frustrated. I want my money back!",
            mixed: "The product quality is excellent and I love the design, but the delivery was delayed and the packaging was damaged. Customer service was helpful in resolving the issue, though it took longer than expected.",
            neutral: "The product arrived on time. It has basic functionality and meets the specifications listed. The price is comparable to similar items in the market."
        };

        let analysisHistory = JSON.parse(localStorage.getItem('sentimentHistory') || '[]');

        // Simulated AWS Comprehend response
        async function simulateAWSComprehend(text) {
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            const positiveWords = ['love', 'excellent', 'great', 'amazing', 'wonderful', 'perfect', 'outstanding', 'fantastic'];
            const negativeWords = ['hate', 'terrible', 'awful', 'worst', 'horrible', 'disappointed', 'frustrated', 'broken'];
            
            const words = text.toLowerCase().split(/\\s+/);
            let positiveScore = 0;
            let negativeScore = 0;
            
            words.forEach(word => {
                if (positiveWords.some(pw => word.includes(pw))) positiveScore++;
                if (negativeWords.some(nw => word.includes(nw))) negativeScore++;
            });
            
            let sentiment, scores;
            if (positiveScore > negativeScore) {
                sentiment = 'POSITIVE';
                scores = {
                    Positive: 0.7 + Math.random() * 0.25,
                    Negative: 0.05 + Math.random() * 0.1,
                    Neutral: 0.1 + Math.random() * 0.15,
                    Mixed: 0.05 + Math.random() * 0.1
                };
            } else if (negativeScore > positiveScore) {
                sentiment = 'NEGATIVE';
                scores = {
                    Negative: 0.7 + Math.random() * 0.25,
                    Positive: 0.05 + Math.random() * 0.1,
                    Neutral: 0.1 + Math.random() * 0.15,
                    Mixed: 0.05 + Math.random() * 0.1
                };
            } else if (positiveScore === negativeScore && positiveScore > 0) {
                sentiment = 'MIXED';
                scores = {
                    Mixed: 0.6 + Math.random() * 0.2,
                    Positive: 0.15 + Math.random() * 0.1,
                    Negative: 0.15 + Math.random() * 0.1,
                    Neutral: 0.05 + Math.random() * 0.1
                };
            } else {
                sentiment = 'NEUTRAL';
                scores = {
                    Neutral: 0.7 + Math.random() * 0.25,
                    Positive: 0.1 + Math.random() * 0.1,
                    Negative: 0.1 + Math.random() * 0.1,
                    Mixed: 0.05 + Math.random() * 0.1
                };
            }
            
            const total = Object.values(scores).reduce((a, b) => a + b, 0);
            Object.keys(scores).forEach(key => {
                scores[key] = scores[key] / total;
            });
            
            return { Sentiment: sentiment, SentimentScore: scores };
        }

        function loadDemo(type) {
            document.getElementById('textInput').value = demoTexts[type];
        }

        async function analyzeSentiment() {
            const textInput = document.getElementById('textInput');
            const text = textInput.value.trim();
            
            if (!text) {
                showError('Please enter some text to analyze.');
                return;
            }
            
            if (text.length < 10) {
                showError('Please enter at least 10 characters for accurate analysis.');
                return;
            }
            
            hideError();
            setLoading(true);
            
            try {
                const response = await simulateAWSComprehend(text);
                displayResults(response, text);
                saveToHistory(text, response);
                updateHistoryDisplay();
            } catch (error) {
                showError('Analysis failed. In a real app, check your AWS credentials and permissions.');
            }
            
            setLoading(false);
        }

        function displayResults(response, originalText) {
            const resultsSection = document.getElementById('resultsSection');
            const sentimentCard = document.getElementById('sentimentCard');
            
            const sentiment = response.Sentiment.toLowerCase();
            const scores = response.SentimentScore;
            const confidence = Math.max(...Object.values(scores)) * 100;
            
            const sentimentColors = {
                positive: '#10B981',
                negative: '#EF4444',
                neutral: '#6B7280',
                mixed: '#F59E0B'
            };
            
            sentimentCard.innerHTML = \`
                <div class="sentiment-header">
                    <div class="sentiment-main sentiment-\${sentiment}">
                        \${getSentimentEmoji(sentiment)} \${sentiment}
                    </div>
                    <div class="confidence-badge">
                        Confidence: \${confidence.toFixed(1)}%
                    </div>
                </div>
                
                <div class="scores-grid">
                    \${Object.entries(scores).map(([key, value]) => \`
                        <div class="score-item">
                            <div class="score-label">\${key}</div>
                            <div class="score-value" style="color: \${sentimentColors[key.toLowerCase()] || '#6B7280'}">
                                \${(value * 100).toFixed(1)}%
                            </div>
                            <div class="score-bar">
                                <div class="score-fill" style="width: \${value * 100}%; background-color: \${sentimentColors[key.toLowerCase()] || '#6B7280'}"></div>
                            </div>
                        </div>
                    \`).join('')}
                </div>
                
                <div style="margin-top: 20px; padding: 15px; background: #F9FAFB; border-radius: 8px;">
                    <strong>Analyzed Text:</strong>
                    <p style="margin-top: 8px; color: #374151; font-style: italic;">
                        "\${originalText.substring(0, 200)}\${originalText.length > 200 ? '...' : ''}"
                    </p>
                </div>
            \`;
            
            resultsSection.style.display = 'block';
            resultsSection.scrollIntoView({ behavior: 'smooth' });
        }

        function getSentimentEmoji(sentiment) {
            const emojis = {
                positive: '😊',
                negative: '😞',
                neutral: '😐',
                mixed: '🤔'
            };
            return emojis[sentiment] || '🤖';
        }

        function saveToHistory(text, response) {
            const historyItem = {
                id: Date.now(),
                text: text.substring(0, 100) + (text.length > 100 ? '...' : ''),
                sentiment: response.Sentiment,
                confidence: Math.max(...Object.values(response.SentimentScore)) * 100,
                timestamp: new Date().toLocaleString()
            };
            
            analysisHistory.unshift(historyItem);
            analysisHistory = analysisHistory.slice(0, 10);
            localStorage.setItem('sentimentHistory', JSON.stringify(analysisHistory));
        }

        function updateHistoryDisplay() {
            const historySection = document.getElementById('historySection');
            const historyList = document.getElementById('historyList');
            
            if (analysisHistory.length === 0) {
                historySection.style.display = 'none';
                return;
            }
            
            historyList.innerHTML = analysisHistory.map(item => \`
                <div class="history-item">
                    <div class="history-text">"\${item.text}"</div>
                    <div class="history-result">
                        <span class="sentiment-\${item.sentiment.toLowerCase()}">
                            \${getSentimentEmoji(item.sentiment.toLowerCase())} \${item.sentiment}
                        </span>
                        <span style="color: #6B7280; font-size: 0.8em;">\${item.timestamp}</span>
                    </div>
                </div>
            \`).join('');
            
            historySection.style.display = 'block';
        }

        function clearAll() {
            document.getElementById('textInput').value = '';
            document.getElementById('resultsSection').style.display = 'none';
            analysisHistory = [];
            localStorage.removeItem('sentimentHistory');
            updateHistoryDisplay();
            hideError();
        }

        function setLoading(loading) {
            const loadingEl = document.getElementById('loading');
            const analyzeBtn = document.getElementById('analyzeBtn');
            
            if (loading) {
                loadingEl.style.display = 'flex';
                analyzeBtn.disabled = true;
                analyzeBtn.textContent = 'Analyzing...';
            } else {
                loadingEl.style.display = 'none';
                analyzeBtn.disabled = false;
                analyzeBtn.textContent = '🔍 Analyze Sentiment';
            }
        }

        function showError(message) {
            const errorEl = document.getElementById('error');
            errorEl.textContent = message;
            errorEl.style.display = 'block';
        }

        function hideError() {
            document.getElementById('error').style.display = 'none';
        }

        document.addEventListener('DOMContentLoaded', function() {
            updateHistoryDisplay();
            
            document.getElementById('textInput').addEventListener('keydown', function(e) {
                if (e.ctrlKey && e.key === 'Enter') {
                    analyzeSentiment();
                }
            });
        });
    </script>
</body>
</html>`}
            width="100%"
            height="600px"
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
};

export default SentimentAnalyzer;